export const hubbleAPI = '/shop/HubbleAPI/api/'
export const hubbleGW = '/shop/gw/api/'
export const hubbleAuthAPI = '/shop/HubbleAuthAPI/api/'
